import * as React from "react";
import { TemplateHelpText } from "~/areas/projects/components/Variables/TenantVariables/TemplateHelpText";
import { TemplateName } from "~/areas/projects/components/Variables/TenantVariables/TemplateName";
import { styles } from "~/areas/projects/components/Variables/TenantVariables/styles";
interface TemplateNameCellProps {
    template: TemplateInfo | null;
}
interface TemplateInfo {
    Id: string;
    Name: string;
    Label: string;
    HelpText: string;
}
export function TemplateNameCell({ template }: TemplateNameCellProps) {
    if (!template) {
        return null;
    }
    return (<div className={styles.templateInfo}>
            <div className={styles.templateName}>
                <TemplateName name={template.Name}/>
                <TemplateHelpText text={template.HelpText}/>
            </div>
            <div className={styles.cellLabel}>{template.Label}</div>
        </div>);
}
